module.exports = __webpack_public_path__ + "img/laboratorio_4-3_1536.d9401144.webp";